import React, { Component } from 'react';
import Button from '../../../forms/button';
import classNames from 'classnames';
import { applyIncludeExcludeFilter } from '../../helpers/filters/filter-helpers';

class Store extends Component {
    
    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        const initialIncludeExcludes = (props.filters && Array.isArray(props.filters.unitsIncludeExclude))
            ? props.filters.unitsIncludeExclude
            : [];

        this.state = {
           value: '',
           selected: null,
           suggestions: [],
           includeExcludes: initialIncludeExcludes,
           isPanelOpen: false//initialIncludeExcludes.length < 21
           //includeFromFile: false
        };
    }

    componentDidUpdate(prevProps) {
        const prevList =
            prevProps.filters && Array.isArray(prevProps.filters.unitsIncludeExclude)
                ? prevProps.filters.unitsIncludeExclude
                : null;
        const nextList =
            this.props.filters && Array.isArray(this.props.filters.unitsIncludeExclude)
                ? this.props.filters.unitsIncludeExclude
                : null;

        if (nextList && nextList !== prevList) {
            this.setState({
                includeExcludes: nextList
            });
        }
    }

    componentDidMount() {
        this.props.registerFilter(this);
        document.addEventListener('click', (e) => this.handleClickOutside(e));
    }

    createObject(selectedUnit) {
        return {
            ...selectedUnit
        }
    }

    filter(units) {
        const filteredUnits = applyIncludeExcludeFilter(
            units,
            this.state.includeExcludes,
            this.props.allUnits
        );

        return {
            filteredUnits,
            filter: {
                unitsIncludeExclude: this.state.includeExcludes
            }
        };
    }

    handleChange(e) {

        const suggestions = this.props.allUnits.filter(unit => (unit.name.toLowerCase().includes(e.currentTarget.value.toLowerCase())) || unit.delfiId.toString().includes(e.currentTarget.value)).slice(0,8);
        const selected = suggestions.length > 0 ? suggestions[0] : null;
        this.setState({
            value: e.currentTarget.value,
            suggestions,
            selected
        });
    }
    handleSelect(selected) {
        this.setState({
            selected,
            value: `${selected.delfiId} ${selected.name}`,
            suggestions: []
        });
    }

    include() {
        this.setState({
            includeExcludes: [...this.state.includeExcludes, this.createObject({ ...this.state.selected, include: true })],
            selected: null,
            value: '',
        }, () => {
            this.props.previewFilter();
        });
    }

    /*inlucdeList(includeExcludes) {
        this.setState({
            includeExcludes,
            selected: null,
            value: '',
            includeFromFile: true
        }, () => {
            this.props.previewFilter();
        });
    }*/

    excludes() {
        this.setState({
            includeExcludes: [...this.state.includeExcludes, this.createObject({ ...this.state.selected, include: false })],
            selected: null,
            value: ''
        }, () =>  {
            this.props.previewFilter();
        });
    }

    delete(item) {
        const includeExcludes = this.state.includeExcludes.filter(inc => inc.delfiId !== item.delfiId);

        this.setState({
            includeExcludes
        }, () => {
            this.props.previewFilter();
        });
    }

    componentWillUnmount() {
        document.removeEventListener('click', (e) => this.handleClickOutside(e));
    }

    handleClickOutside(event) {    
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.setState({
                suggestions: []
            });
        }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    reset() {
        this.setState({
            value: '',
            selected: null,
            suggestions: [],
            includeExcludes: []
        });
    }

    getPropertyName() {
        return this.props.propertyName;
    }

    getValues() {
        return this.state.values;
    }

    render() {

        if (!this.props.allUnits) return null;

        const unitLocalization = this.props.type === 'foodservice' ? 'enhet' : 'butik';

        return (
            <div className="map-filters__filter">
                <h2 className="map-filters__filter-heading map-filters__filter-heading--no-margin">
                    Filtrera enskilda {unitLocalization}er 
                    {this.state.includeExcludes.length > 0 &&
                        <span className="map-filters__inluded-excluded-num">
                            {this.state.includeExcludes.length}
                        </span>
                    }

                    <button type="button" className={classNames({
                        'map-filters__filter-panel-toogler': true,
                        'map-filters__filter-panel-toogler--is-open': this.state.isPanelOpen
                    })} onClick={() => {
                        this.setState({
                            ...this.state,
                            isPanelOpen: !this.state.isPanelOpen
                        });
                    }}></button>
                </h2>
                <section className={classNames({
                    'map-filters__filter-panel': true,
                    'map-filters__filter-panel--is-open': this.state.isPanelOpen
                })}>
                
                    <p>Här kan du inkludera eller exkludera specifika {unitLocalization}er.</p>
                    <label className="map-filters__filter-lbl" htmlFor="search-unit">DelfiNr eller {unitLocalization}ens namn</label>
                    <div className="map-filters__inputs">
                        <div className="map-filters__autocompleter" ref={this.wrapperRef}>
                            <input autoComplete="off" className="map-filters__search-store" id="search-unit" type="text" onChange={(e) => this.handleChange(e)} value={this.state.value} />
                            {this.state.suggestions.length > 0 && 
                                <ul className="map-filters__suggestions">
                                    {this.state.suggestions.map((item) => {
                                        return (
                                            <li key={item.delfiId}>
                                                <button type="button" onClick={() => this.handleSelect(item)}>{item.delfiId} {item.name}</button>
                                            </li>
                                        );
                                    })}
                                </ul>
                            }
                        </div>
                    </div>

                    {this.state.selected &&
                        <div className="map-filters__autocompleter-ctrls">
                            <Button type="button" onClick={() => this.include()}>Inkludera {unitLocalization}en</Button>
                            <Button type="button" onClick={() => this.excludes()}>Exkludera {unitLocalization}en</Button>
                        </div>
                    }
                    
                    {this.state.includeExcludes.length > 0 &&
                        <table className="map-filters__include-exclude">
                            <thead>
                                <tr>
                                    <th>Butik</th>
                                    <th>Ingår i distrikt</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.includeExcludes.map((incEcl, key) => {
                                    return (
                                        <tr key={`${incEcl.delfiId}${key}`}>
                                            <th>
                                                {incEcl.delfiId} {incEcl.name}
                                            </th>
                                            <td>
                                                {incEcl.include ? 'Ja' : 'Nej'}
                                            </td>
                                            <td>
                                                <Button type="button" modifiers={{
                                                    'form__button--small': true
                                                }} onClick={() => this.delete(incEcl)}>{incEcl.include ? 'Ta bort från distriktet' : 'Lägg till i distriktet'}</Button>
                                            </td>
                                        </tr>  
                                    );
                                })}
                            </tbody>
                        </table>
                    }
                </section>
            </div>
           
        );
    }
};

export default Store;